import React, { memo } from 'react';
import cn from 'classnames';
import { Button } from 'components/form';
import Dropdown from 'components/Dropdown';
import { Row, Col } from 'components/layout';
import CancelButton from 'components/CancelButton';
import { Option } from 'lib/models/option';
import styles from './AddSelectOptionEmojiV2.module.scss';

interface Inputs {
  name: string;
}

export interface AddSelectOptionEmojiProps {
  /** Custom class name */
  className?: string;
  options: Array<Option>;
  /** value */
  value?: string;
  /** placeholder */
  placeholder?: string;
  /** label */
  label?: string;
  /** onChange handler */
  onChange?: (value: string) => void;
  /** on remove handler */
  onRemove: (value: string) => void;
  /** on add custom value */
  onCustomAdd?: (input: Inputs) => Promise<unknown>;
  /** is remove button loading */
  isRemoveLoading?: boolean;
  /** is save button loading */
  isSaveLoading?: boolean;
  /** make primary */
  onMakePrimary?: () => void;
  /** is primary */
  isPrimary?: boolean;
  /** label for primary option */
  primaryLabel?: string;
  /** title */
  title?: string;
  /** className for label styling */
  triggerButtonClassName?: string;
}

export const AddSelectOptionEmoji: React.FC<AddSelectOptionEmojiProps> = memo(
  ({
    className = '', // custom class name
    value = '',
    placeholder,
    onChange,
    onRemove,
    options,
    onMakePrimary,
    isPrimary,
    primaryLabel,
    title,
    label = '',
    triggerButtonClassName = '',
  }: AddSelectOptionEmojiProps) => {
    const contentClassNames = cn(
      styles.AddSelectOptionEmoji,
      { [styles.isSecondary]: !isPrimary },
      className
    );

    return (
      <Row
        align="center"
        className={contentClassNames}
        data-testid="AddSelectOptionEmoji"
      >
        <Dropdown
          title={title || ''}
          placeholder={placeholder}
          className={cn(
            styles.AddSelectOptionEmojiDropdown,
            styles.dropdownButton
          )}
          options={options}
          label={label}
          value={value}
          onChange={(item: string) => onChange && onChange(item)}
          alignment="right"
          hasPrimaryBg={!value}
          hideChevronIconOnDisabled
          triggerButtonClassName={cn(
            styles.AddSelectOptionEmojiDropdownTriggerButton,
            triggerButtonClassName
          )}
        />
        {onMakePrimary &&
          (isPrimary ? (
            <Button
              className={cn(styles.button, styles.AddSelectOptionEmojiPrimary)}
              size="small"
              variant="text"
              color="primary"
              type="button"
            >
              {primaryLabel || 'Primary'}
            </Button>
          ) : (
            <Button
              color="primary-light"
              size="small"
              type="button"
              borderless
              onClick={onMakePrimary}
              className={styles.button}
            >
              Make Focus
            </Button>
          ))}
        <Col>
          <CancelButton
            onRemove={() => onRemove(value)}
            className={styles.cancelButton}
            isShow={true}
          />
        </Col>
      </Row>
    );
  }
);

AddSelectOptionEmoji.displayName = 'AddSelectOptionEmoji';
